module.exports = __webpack_public_path__ + "img/erweima1015.feaed47b.png";